import React, { FunctionComponent } from 'react';
import 'react-tooltip/dist/react-tooltip.css';

import './index.css';

import 'assets/images/favicon.ico';
import Routes from 'routes';
import { TooltipProvider } from '@epoch-ui/components/Tooltip';
import { QueryProviders } from '@providers/QueryProviders';

const App: FunctionComponent<React.PropsWithChildren<unknown>> = () => (
  <QueryProviders>
    <TooltipProvider delayDuration={200}>
      <Routes />
    </TooltipProvider>
  </QueryProviders>
);

export default App;
